import { AfterContentInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { LocalStorageKeys } from '@app/services/local-storage.service';

@Component({
  standalone: false,
  selector: 'ti-iframe-content',
  templateUrl: 'iframe-content.component.html',
  styleUrls: ['iframe-content.component.sass'],
})
export class IframeContentComponent implements AfterContentInit {
  readonly localStorageKeys = LocalStorageKeys;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  @Output() close = new EventEmitter<any>();
  @Output() init = new EventEmitter();
  url: string;
  @ViewChild('content') content: ElementRef;

  value: string = '';

  ngAfterContentInit(): void {
    this.init.emit(this.content);
  }
}
